import $ from "jquery";
import { MagnificPopup } from "../../../javascripts/common/dynamic-imports/MagnificPopup";
const magnificPopup = new MagnificPopup();
$('.OrderAddressDetailChangeStoreClosedShowSuccessPopinButton').on('click', function (e) {
  e.preventDefault();
  magnificPopup.open({
    items: {
      src: $('.js-confirmOrderAddressDetailChangeStoreClosedSuccessPopin'),
      type: 'inline',
    },
    showCloseBtn: false,
    closeOnBgClick: false,
    mainClass: 'account-popin-wrapper'
  });
});

$('.OrderAddressDetailChangeStoreClosedShowFailurePopinButton').on('click', function (e) {
  e.preventDefault();
  magnificPopup.open({
    items: {
      src: $('.js-confirmOrderAddressDetailChangeStoreClosedFailurePopin'),
      type: 'inline',
    },
    showCloseBtn: false,
    closeOnBgClick: false,
    mainClass: 'account-popin-wrapper'
  });
});
